function initArtistPicks() {
  document.querySelectorAll('.ap').forEach(function (section) {
    if (section.dataset.apInitialized === 'true') return;
    section.dataset.apInitialized = 'true';

    var mode = section.dataset.displayMode || 'tabs';
    var panels = Array.from(section.querySelectorAll('.ap__panel'));
    var tabs = Array.from(section.querySelectorAll('.ap__tab'));

    if (panels.length === 0) return;

    function parseDate(value, endOfDay) {
      if (!value) return null;

      var parts = value.split('-');
      if (parts.length !== 3) return null;

      var year = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10) - 1;
      var day = parseInt(parts[2], 10);

      if (isNaN(year) || isNaN(month) || isNaN(day)) return null;

      var date = new Date(year, month, day);

      if (endOfDay) {
        date.setHours(23, 59, 59, 999);
      } else {
        date.setHours(0, 0, 0, 0);
      }

      return date;
    }

    function formatMonthDay(date) {
      return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric'
      });
    }

    function getPanelByCity(cityId) {
      return panels.find(function (panel) {
        return panel.dataset.city === cityId;
      });
    }

    function getCityStatus(panel, today) {
      var start = parseDate(panel.dataset.start, false);
      var end = parseDate(panel.dataset.end, true);

      if (end && today > end) {
        return {
          state: 'expired',
          start: start,
          end: end
        };
      }

      if (start && today < start) {
        return {
          state: 'future',
          start: start,
          end: end
        };
      }

      return {
        state: 'active',
        start: start,
        end: end
      };
    }

    function initToggle(panel) {
      if (panel.dataset.apToggleInitialized === 'true') return;
      panel.dataset.apToggleInitialized = 'true';

      var toggleBtns = Array.from(panel.querySelectorAll('.ap__toggle-btn'));
      var artistCards = Array.from(panel.querySelectorAll('.ap__artist-card'));
      var products = Array.from(panel.querySelectorAll('.ap__product'));

      function selectArtist(artist) {
        panel.dataset.activeArtist = artist;

        toggleBtns.forEach(function (btn) {
          btn.classList.toggle('active', btn.dataset.artist === artist);
        });

        artistCards.forEach(function (card) {
          card.classList.toggle('active', card.classList.contains('ap__artist-card--' + artist));
        });

        products.forEach(function (prod) {
          prod.classList.toggle('active', prod.classList.contains('ap__product--' + artist));
        });
      }

      toggleBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectArtist(btn.dataset.artist);
        });
      });

      selectArtist(panel.dataset.activeArtist || 'a');
    }

    function showCity(cityId) {
      panels.forEach(function (panel) {
        panel.hidden = true;
      });

      tabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', 'false');
      });

      var target = getPanelByCity(cityId);

      if (target) {
        target.hidden = false;
        initToggle(target);
      }

      var activeTab = tabs.find(function (tab) {
        return tab.dataset.city === cityId;
      });

      if (activeTab) {
        activeTab.setAttribute('aria-selected', 'true');
      }
    }

    function bindTabClicks() {
      tabs.forEach(function (tab) {
        if (tab.dataset.apClickBound === 'true') return;
        tab.dataset.apClickBound = 'true';

        tab.addEventListener('click', function () {
          if (tab.disabled || tab.classList.contains('is-disabled') || tab.hidden) return;
          showCity(tab.dataset.city);
        });
      });
    }

    function clearScheduledTabState(tab) {
      tab.hidden = false;
      tab.disabled = false;
      tab.classList.remove('is-disabled');
      tab.removeAttribute('aria-disabled');
      tab.removeAttribute('title');
    }

    function applyScheduledMode() {
      var today = new Date();
      today.setHours(0, 0, 0, 0);

      var activeCity = null;
      var firstFutureCity = null;

      tabs.forEach(function (tab) {
        var panel = getPanelByCity(tab.dataset.city);
        if (!panel) return;

        var status = getCityStatus(panel, today);

        clearScheduledTabState(tab);

        if (status.state === 'expired') {
          tab.hidden = true;
          panel.hidden = true;
          return;
        }

        if (status.state === 'future') {
          tab.disabled = true;
          tab.classList.add('is-disabled');
          tab.setAttribute('aria-disabled', 'true');

          if (status.start) {
            tab.setAttribute('title', 'Available on ' + formatMonthDay(status.start));
          }

          if (!firstFutureCity) {
            firstFutureCity = tab.dataset.city;
          }

          return;
        }

        if (!activeCity) {
          activeCity = tab.dataset.city;
        }
      });

      if (activeCity) {
        showCity(activeCity);
      } else if (firstFutureCity) {
        showCity(firstFutureCity);
      } else {
        var firstVisibleTab = tabs.find(function (tab) {
          return !tab.hidden;
        });

        if (firstVisibleTab) {
          showCity(firstVisibleTab.dataset.city);
        }
      }
    }

    function applyTabsMode() {
      tabs.forEach(function (tab) {
        clearScheduledTabState(tab);
      });

      if (tabs.length > 0) {
        showCity(tabs[0].dataset.city);
      }
    }

    bindTabClicks();

    if (mode === 'scheduled') {
      applyScheduledMode();
    } else {
      applyTabsMode();
    }
  });
}

document.addEventListener('DOMContentLoaded', initArtistPicks);

if (document.readyState !== 'loading') {
  initArtistPicks();
}